import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import { Button, Column, Form, Input, Modal } from '../../../..'
import { storeForm } from '../../../../../types'
import Expander from '../../../../Expander'

const { FormGroup, FormHeader, Label } = Form

class StoreForm extends PureComponent {
    static propTypes = {
        errors: PropTypes.shape({
            code: PropTypes.string,
            name: PropTypes.string,
            phone_primary: PropTypes.string,
            phone_secondary: PropTypes.string,
            email: PropTypes.string,
            slug: PropTypes.string,
            postcode: PropTypes.string,
            address: PropTypes.string,
            chain_id: PropTypes.string,
            country_code: PropTypes.string,
            lat: PropTypes.string,
            lng: PropTypes.string,
        }),
        innerRef: PropTypes.shape({}),
        isOpen: PropTypes.bool,
        fetchingData: PropTypes.bool,
        store: PropTypes.shape(storeForm),
        onChangeForm: PropTypes.shape({
            code: PropTypes.func,
            name: PropTypes.func,
            phone_primary: PropTypes.func,
            phone_secondary: PropTypes.func,
            email: PropTypes.func,
            slug: PropTypes.func,
            postcode: PropTypes.func,
            address: PropTypes.func,
            chain_id: PropTypes.func,
            country_code: PropTypes.func,
            lat: PropTypes.func,
            lng: PropTypes.func,
        }),
        storeCode: PropTypes.string,
        onClickCancel: PropTypes.func,
        onClickSubmit: PropTypes.func,
        availableCountries: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
        availableChains: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
        t: PropTypes.func.isRequired,
    }

    static defaultProps = {
        errors: {
            code: null,
            name: null,
            phone_primary: null,
            phone_secondary: null,
            email: null,
            slug: null,
            postcode: null,
            address: null,
            chain_id: null,
            country_code: null,
            lat: null,
            lng: null,
        },
        storeCode: null,
        innerRef: null,
        isOpen: false,
        fetchingData: false,
        onChangeForm: {
            code: () => null,
            name: () => null,
            phone_primary: () => null,
            phone_secondary: () => null,
            email: () => null,
            slug: () => null,
            postcode: () => null,
            address: () => null,
            chain_id: () => null,
            country_code: () => null,
            lat: () => null,
            lng: () => null,
        },
        onClickCancel: () => null,
        onClickSubmit: () => null,
    }

    renderAcceptButton = () => {
        const { fetchingData, storeCode, t } = this.props
        if (fetchingData) return '...'
        if (storeCode) return t('Update')
        return t('Create')
    }

    render() {
        const { isOpen, fetchingData, onChangeForm, onClickCancel, onClickSubmit, store, errors, availableChains, availableCountries, storeCode, t } =
            this.props
        const { code, name, phone_primary, phone_secondary, email, slug, postcode, address, chain_id, country_code, lat, lng } = store
        const {
            code: onChangeCode,
            name: onChangeName,
            phone_primary: onChangePhonePrimary,
            phone_secondary: onChangePhoneSecondary,
            email: onChangeEmail,
            slug: onChangeSlug,
            postcode: onChangePostCode,
            address: onChangeAddress,
            chain_id: onChangeChain,
            country_code: onChangeCountry,
            lat: onChangeLat,
            lng: onChangeLng,
        } = onChangeForm
        const {
            code: code_error,
            name: name_error,
            phone_primary: phone_primary_error,
            phone_secondary: phone_secondary_error,
            email: email_error,
            slug: slug_error,
            postcode: postcode_error,
            address: address_error,
            chain_id: chain_id_error,
            country_code: country_code_error,
            lat: lat_error,
            lng: lng_error,
        } = errors
        return (
            <Modal isOpen={isOpen} onClose={onClickCancel} scrollable>
                <Form>
                    <FormHeader>{storeCode ? t('Edit store') : t('Create store')}</FormHeader>
                    <FormGroup title="Store" scrollable>
                        <Label id="code" label={t('Code')} error={code_error}>
                            <Input
                                id="code"
                                name="code"
                                type="text"
                                onChange={onChangeCode}
                                size="md"
                                value={code}
                                error={!!code_error}
                                disabled={fetchingData}
                            />
                        </Label>
                        <Label id="name" label={t('Name')} error={name_error}>
                            <Input
                                id="name"
                                name="name"
                                type="text"
                                onChange={onChangeName}
                                size="md"
                                value={name}
                                error={!!name_error}
                                disabled={fetchingData}
                            />
                        </Label>
                        <Label id="phone_primary" label={t('Primary phone')} error={phone_primary_error}>
                            <Input
                                id="phone_primary"
                                name="phone_primary"
                                type="text"
                                onChange={onChangePhonePrimary}
                                size="md"
                                value={phone_primary}
                                error={!!phone_primary_error}
                                disabled={fetchingData}
                            />
                        </Label>
                        <Label id="phone_secondary" label={t('Secondary phone')} error={phone_secondary_error}>
                            <Input
                                id="phone_secondary"
                                name="phone_secondary"
                                type="text"
                                onChange={onChangePhoneSecondary}
                                size="md"
                                value={phone_secondary}
                                error={!!phone_secondary_error}
                                disabled={fetchingData}
                            />
                        </Label>
                        <Label id="email" label="Email" error={email_error}>
                            <Input
                                id="email"
                                name="email"
                                type="text"
                                onChange={onChangeEmail}
                                size="md"
                                value={email}
                                error={!!email_error}
                                disabled={fetchingData}
                            />
                        </Label>
                    </FormGroup>
                    <FormGroup title={t('Store location')} scrollable>
                        <Label id="address" label={t('Address')} error={address_error}>
                            <Input
                                id="address"
                                name="address"
                                type="text"
                                onChange={onChangeAddress}
                                size="md"
                                value={address}
                                error={!!address_error}
                                disabled={fetchingData}
                            />
                        </Label>
                        <Label id="postcode" label={t('Post code')} error={postcode_error}>
                            <Input
                                id="postcode"
                                name="postcode"
                                type="text"
                                onChange={onChangePostCode}
                                size="md"
                                value={postcode}
                                error={!!postcode_error}
                                disabled={fetchingData}
                            />
                        </Label>
                        <Label id="country_code" label={t('Country')} error={country_code_error}>
                            <Input
                                id="country_code"
                                name="country_code"
                                type="select"
                                onChange={onChangeCountry}
                                size="md"
                                value={country_code}
                                values={availableCountries}
                                error={!!country_code_error}
                                disabled={fetchingData}
                            />
                        </Label>
                        <Label id="lat" label="Lat" error={lat_error}>
                            <Input id="lat" name="lat" type="text" onChange={onChangeLat} size="md" value={lat} error={!!lat_error} disabled={fetchingData} />
                        </Label>
                        <Label id="lng" label="Lng" error={lng_error}>
                            <Input id="lng" name="lng" type="text" onChange={onChangeLng} size="md" value={lng} error={!!lng_error} disabled={fetchingData} />
                        </Label>
                    </FormGroup>
                    <FormGroup title={t('Advanced options')} scrollable>
                        <Expander icon="cogs" header={t('Advanced options')} disabled={fetchingData}>
                            <Label id="chain_id" label={t('Chain')} error={chain_id_error}>
                                <Input
                                    id="chain_id"
                                    name="chain_id"
                                    type="select"
                                    onChange={onChangeChain}
                                    size="md"
                                    value={chain_id}
                                    values={availableChains}
                                    error={!!chain_id_error}
                                    disabled={fetchingData}
                                />
                            </Label>
                            <Label id="slug" label={t('Slug')} error={slug_error}>
                                <Input id="slug" name="slug" type="text" onChange={onChangeSlug} size="md" value={slug} error={!!slug_error} disabled />
                            </Label>
                        </Expander>
                    </FormGroup>
                    <FormGroup>
                        <Column right width="100%">
                            <Button theme="light" onClick={onClickCancel} size="sm">
                                {t('Cancel')}
                            </Button>
                            <Button onClick={onClickSubmit} size="sm" theme={fetchingData ? 'loading' : 'primary'} disabled={fetchingData}>
                                {this.renderAcceptButton()}
                            </Button>
                        </Column>
                    </FormGroup>
                </Form>
            </Modal>
        )
    }
}

export default withTranslation()(StoreForm)
